@if (error) {
  <div class="err-global-msg-box mob_padd">
    <div class="err-golbal-content">
      @for (err of errorArray; track err) {
        <div>
          <span>
            {{'common.text_orderimport_error_errorinline_message'|cxTranslate}}&nbsp;
            {{err?.lineNumber}}:&nbsp;
            @for (message  of err?.messageList; track message ) {
              @if (!(message?.url)) {
                <span [innerHTML]='message.message|cxTranslate|convertToHtml'></span>{{message.errorValue1}}
              }
              @if ((message?.url)) {
                <span [innerHtml]='message|cxTranslateAndFormat'></span>
              }
            }
          </span>
        </div>
      }
      <div>{{'common.text_orderimport_error_allotherlines_message'|cxTranslate}}</div>
    </div>
    <div class="closer" (click)="error = !error">x</div>
  </div>
}
@if (isUploading) {
  <div class="uploader-content mob_padd">
    <div class="upload-text">{{'common.import_csv_savedCart_uploadStarted'|cxTranslate}}</div>
    <div class="closer">x</div>
  </div>
}
<div class="account-section mob_padd">
  <h1 class="section-header f-24-title m-0">{{'common.text_quickorder_template'|cxTranslate}}</h1>
  <div class="account-section-header no-border f-24 c-black">
    {{'common.import_csv_savedCart_title'|cxTranslate}}
    <div class="account-section-header__subheadline f-20 c-black mt-3" [innerHTML]='subheadlineKey|cxTranslate'>
    {{'common.import_csv_savedCart_filesNote'|cxTranslate}}</div>
  </div>
  <div class="account-section-content import-csv__content">
    <div class="row">
      <div class="col-xs-12 col-sm-12 import-csv__file-spec f-20 c-black">
        <div class="order-import-text">{{'common.import_csv_savedCart_fileContentNoteEmea'|cxTranslate}}<span
          class="c-blue-bold">
        {{'common.import_csv_savedCart_downloadTemplate'|cxTranslate}}</span>{{'common.import_csv_savedCart_enterContentNoteEmea'|cxTranslate}}<span
      class="c-blue-bold"> {{'common.import_csv_savedCart_uploadTemplate'|cxTranslate}}</span></div>
      <ul>
        <li class="import-csv__file-spec-item">{{'common.import_csv_savedCart_fileContent'|cxTranslate}}
        </li>
        <li class="import-csv__file-spec-item">{{'common.order_quantity'|cxTranslate}}</li>
        <li class="import-csv__file-spec-item">{{'common.import_csv_savedCart_requestedDate'|cxTranslate}}
        </li>
        <li class="import-csv__file-spec-item">
        {{'common.import_csv_savedCart_customerPartNumber'|cxTranslate}}</li>
      </ul>
    </div>
    <div class="row import-order-type-select ">
      <div class=" px-0 col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="selectboxdiv">
          <div class="col-sm-12 col-md-12 col-lg-8 order-type f-24 c-black">
          {{'common.quickorder_page_ordertypes'|cxTranslate}}</div>
          <div class=" col-sm-12 col-md-12 col-lg-4 order-type-select">
            <select class="form-control" id="cart-order-type" #dropdown
              (change)="onDropdownChange(dropdown.value)">
              <option value="null" [selected]="orderType == undefined" disabled>
              {{'common.quickorder_page_ordertypes'|cxTranslate}}</option>
              @for (item of entry?.['orderType']['entry']; track item) {
                <option [value]="item.key"
                  [selected]="item.key == orderType">
                  {{item.value}}
                </option>
              }
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="row import-order-type-select">
      <div class="col-md-12 col-lg-6 mb-3 mb-lg-0 download_btn_div">
        <a href='{{baseUrl}}{{mediaUrl}}' download="OrderTemplate.csv"
          class="btn btn-primary btn-block f-24-btn">{{'common.import_csv_savedCart_downloadTemplate'|cxTranslate}}
          <img src="/icons/link-grey.svg" style="width: 35px;" class="whiteArrow" alt="Link Icon">
        </a>
      </div>
      <div class="col-md-12 col-lg-6 import-button-block">
        <div class="form-group file-upload js-file-upload">
          <div class="file-upload__wrapper btn btn-primary btn-block" id="chooseFileButton">
            <span class="f-24-btn">{{'common.import_csv_savedCart_chooseFile'|cxTranslate}}</span>
            <img src="/icons/link-grey.svg" style="width: 35px;" class="whiteArrow" alt="Link Icon">
            <input type="file" id="csvFile" name="csvFile" #fileInput
              class="file-upload__input js-file-upload__input " (input)="onFileSelected(fileInput)"
              accept=".csv">
            </div>
          </div>
          <div class="upload-order-template-text f-16">
          {{'common.import_csv_savedCart_importCondition'|cxTranslate}}</div>
        </div>
      </div>
    </div>
  </div>
</div>